export const tag: Record<string, { value: string; nsfw?: boolean }> = {
  Game: { value: "Game" },
  Action: { value: "Action" },
  Anime: { value: "Anime" },
  Futanari: { value: "Futanari", nsfw: true },
  Femboy: { value: "Femboy" },
  Tomboy: { value: "Tomboy" },
  Comedy: { value: "Comedy" },
  OC: { value: "OC" },
  Fictional: { value: "Fictional" },
  Movie: { value: "Movie" },
  Historical: { value: "Historical" },
  Royalty: { value: "Royalty" },
  Detective: { value: "Detective" },
  Hero: { value: "Hero" },
  Villain: { value: "Villain" },
  Magical: { value: "Magical" },
  Monster: { value: "Monster" },
  MonsterGirl: { value: "Monster Girl" },
  Alien: { value: "Alien" },
  Robot: { value: "Robot" },
  Politics: { value: "Politics" },
  Vampire: { value: "Vampire" },
  Giant: { value: "Giant" },
  Multiple: { value: "Multiple" },
  VTuber: { value: "VTuber" },
  Femdom: { value: "Femdom", nsfw: true },
  Dominant: { value: "Dominant" },
  Submissive: { value: "Submissive" },
  MILF: { value: "MILF", nsfw: true },
  DILF: { value: "DILF", nsfw: true },
  Yandere: { value: "Yandere" },
  Tsundere: { value: "Tsundere" },
  Pokemon: { value: "Pokemon" },
  Assistant: { value: "Assistant" },
  NonEnglish: { value: "Non-English" },
  Demon: { value: "Demon" },
  Philosophy: { value: "Philosophy" },
  RPG: { value: "RPG" },
  Religion: { value: "Religion" },
  Books: { value: "Books" },
  Fairytale: { value: "Fairytale" },
  Mythology: { value: "Mythology" },
  Gay: { value: "Gay" },
  Lesbian: { value: "Lesbian" },
  Bisexual: { value: "Bisexual" },
  Kinky: { value: "Kinky", nsfw: true },
  Seductive: { value: "Seductive", nsfw: true },
  NTR: { value: "NTR", nsfw: true },
  Fantasy: { value: "Fantasy" },
  Straight: { value: "Straight" },
  Vore: { value: "Vore", nsfw: true },
  SciFi: { value: "Sci-Fi" },
  Cheating: { value: "Cheating", nsfw: true },
  BDSM: { value: "BDSM", nsfw: true },
  CNC: { value: "CNC", nsfw: true },
  Vanilla: { value: "Vanilla", nsfw: true },
  Omegaverse: { value: "Omegaverse" },
  Hetero: { value: "Hetero" },
  Horror: { value: "Horror" },
  Mafia: { value: "Mafia" },
  Angel: { value: "Angel" },
  Cute: { value: "Cute" },
  Cartoon: { value: "Cartoon" },
  Caring: { value: "Caring" },
  Friend: { value: "Friend" },
  Feral: { value: "Feral" },
  Expansion: { value: "Expansion", nsfw: true },
  Corruption: { value: "Corruption", nsfw: true },
  Kuudere: { value: "Kuudere" },
  Story: { value: "Story" },
};
